import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";
import { t } from "i18next";
import { Trash2Icon } from "lucide-react";

type optionsGroupProps = {
  id: number;
  name: string;
  color: string;
};

export type TableListGruposProps = {
  optionsGroup: optionsGroupProps[];
  editGroups: (group: optionsGroupProps) => void;
  onDelete?: (group: optionsGroupProps["id"]) => void;
};

const TableListGrupos: React.FC<TableListGruposProps> = ({
  optionsGroup = [],
  editGroups,
  onDelete,
}) => {
  return (
    <div className="">
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        {/* Añadir un contenedor con scroll */}
        <div className="overflow-x-auto max-h-[60vh]">
          <div className="inline-block min-w-full align-middle">
            {optionsGroup.length === 0 ? (
              <Empty texto={t("lesson.views.no_groups")} />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.name")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.color")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {optionsGroup.map((group) => (
                      <tr key={group.id}>
                        <ColumnText title={group.name} />
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <div
                            style={{ backgroundColor: group.color }}
                            className="w-8 h-8 rounded-sm inline-block mr-2"
                          ></div>
                        </td>
                        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                          <div className="flex items-center justify-end">
                            <a
                              onClick={() => {
                                editGroups(group);
                              }}
                              href="#"
                              className="text-primary-500 hover:text-primary-900 mr-4"
                            >
                              {t("general.edit")}
                              <span className="sr-only"></span>
                            </a>
                            {onDelete && (
                              <button
                                onClick={() => {
                                  onDelete(group.id);
                                }}
                                className="text-red-500 hover:text-primary-900"
                              >
                                <Trash2Icon />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListGrupos;
